customElements.define(
  "cc-checkbox", 
  class extends HTMLElement{  
    static get observedAttributes(){
      return ["value"];
    }
    constructor(){
      
      super();
      
      this.height = Number( this.getAttribute("height"))
      
      this.attachShadow({mode:"open"});
      
      this.render();
      
    }
    css = ()=>{
      return `
        :host{
          position:relative;
          width:${this.height * 2}px;
          height:${this.height}px;
          display: flex;
          background-color:red;

          border-radius:100vh;
          overflow:hidden;
        }
        label{
          height:100%;
          width:100%;
          display:flex;
          justify-content:flex-start;
          align-items:center;
          cursor:pointer;
          
        }
        .toggle{
          height: calc(100% - 6px);
          width: calc(50% - 6px);
          margin: 3px;
          border-radius:100vh;
          background-color:white;
        }
        input{
          display:none;
        }

      `;
    }
    template = ()=>{  
      
      return `
        <label id='cb-label' for='cb'>
           <input type='checkbox' id='cb' />
           <div class='toggle'></div>
        </label>        
      `;
    }
    render(){
      
      this.shadowRoot.innerHTML = `
      
        <style>${this.css().trim()}</style>
        
        ${this.template().trim()}
        
      `;
      
      this.shadowRoot.querySelector("#cb").addEventListener("change", this.updateState);
      
    }
    updateState = ()=>{

        if(this.shadowRoot.querySelector("#cb").checked){
          this.toggleOn();
          this.setAttribute("value", 1);
        }else{
          this.toggleOff();
          this.setAttribute("value", 0);
          
        }
    }
    toggleOn(){
      
      this.shadowRoot.querySelector("#cb").checked = true;
      this.shadowRoot.querySelector("#cb-label").style.justifyContent = "flex-end";
      this.shadowRoot.querySelector("#cb-label").style.backgroundColor = getComputedStyle(document.documentElement).getPropertyValue('--site-accent').trim();
      
    }
    toggleOff(){
      this.shadowRoot.querySelector("#cb").checked = false;
      this.shadowRoot.querySelector("#cb-label").style.justifyContent = "flex-start";
      this.shadowRoot.querySelector("#cb-label").style.backgroundColor = "transparent";
      
    }     
    set value(value){
      
      this.setAttribute("value", value);
      
      if(value == 0){
        
        this.toggleOff();
        
      }else{
        
        this.toggleOn();
        
      }
      
    }
    get value(){
      return Number( this.getAttribute("value"));
    }
    attributeChangedCallback(name){
      
      let value = Number(this.value);
      
      if(name === "value"){
        
        if(value == 0){
          
          this.toggleOff();
          
        }else{
          
          this.toggleOn();
          
        }

      }
      
      
    }
  }
);